import Add from '@mui/icons-material/Add'
import {styled} from '@mui/material'
import {Texts} from 'appearance'
import Button from 'components/Control/Button'
import {useI18n} from 'store/Store'

const TableTitle = ({
    tableName,
    itemName,
    handleAddNew,
    allowAdd = true,
    leadingActions,
    additionalActions,
}) => {
    const {i18n} = useI18n()
    const hasSecondaryToolbar =
        (leadingActions?.length ?? 0) > 0 ||
        (additionalActions?.length ?? 0) > 0

    return (
        <Container>
            <TitleContainer>
                <TableName>{i18n.t(`tables.${tableName}`)}</TableName>
                <ButtonsContainer>
                    {allowAdd && (
                        <AddButton
                            startIcon={<Add />}
                            onClick={() => handleAddNew()}>
                            {i18n.t('tables.addNew', {
                                itemName: i18n.t(`tables.${itemName}`),
                            })}
                        </AddButton>
                    )}
                </ButtonsContainer>
            </TitleContainer>

            {hasSecondaryToolbar && (
                <SecondaryToolbar>
                    <ToolbarStart>
                        {leadingActions?.map((button) => (
                            <Button
                                variant={button.variant ?? 'outlined'}
                                key={button.label}
                                onClick={button.onClick}
                                startIcon={button.icon}
                                disabled={button.disabled}
                                color={button.color}>
                                {button.label}
                            </Button>
                        ))}
                    </ToolbarStart>
                    <ToolbarEnd>
                        {additionalActions?.map((button) => (
                            <Button
                                variant="contained"
                                key={button.label}
                                onClick={button.onClick}
                                startIcon={button.icon}>
                                {button.label}
                            </Button>
                        ))}
                    </ToolbarEnd>
                </SecondaryToolbar>
            )}
        </Container>
    )
}

export default TableTitle

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px 0;
`

const TitleContainer = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const ButtonsContainer = styled('div')`
    display: flex;
    gap: 12px;
    align-self: flex-end;
`

const SecondaryToolbar = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
`

const ToolbarStart = styled('div')`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
`

const ToolbarEnd = styled('div')`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    margin-inline-start: auto;
`

const TableName = styled(Texts.Text)(({theme}) => ({
    fontWeight: 500,
    fontSize: 24,
    color: theme.palette.primary.main,
}))

const AddButton = styled(Button)`
    font-weight: 500;
`
